<div class="resp-container">

    <div class="resp-iframe">
        <iframe 
            style="width: 100%; height: 92%; background-color: aliceblue;"
            [src]="thebluedotsURL">
        </iframe>
    </div>

 

</div>